import { useMemo } from 'react';
import { useIsAdmin } from '@olo-web/domain/firebaseAuth/hooks/useIsAdmin';
import { useMerchantTheme } from '@domain/merchants/queries/useMerchantTheme';
import { useThemeAuthUser } from '@olo-web/utils/google/firebase';

type T = {
  isAdmin: boolean;
  isEditor: boolean;
  isOwner: boolean;
};

export const useThemeRoles = (uid?: string): T => {
  const { data: theme } = useMerchantTheme();
  const user = useThemeAuthUser();
  const isAdmin = useIsAdmin();

  const [isOwner, isEditor] = useMemo(() => {
    const userId = uid || user?.uid;
    return [theme?.owners?.includes(userId), theme?.editors?.includes(userId)];
  }, [theme?.editors, theme?.owners, user?.uid, uid]);

  return {
    isAdmin,
    isEditor,
    isOwner,
  };
};
